import React from "react";
import PageHero from "../../../components/ui/PageHero";
import heroHome from "../../../assets/home-hero.jpg";

export const Hero: React.FC = () => (
  <PageHero
    src={heroHome}
    title="Club Sportif Volley-Ball de Viarmes"
    subtitle="Esprit d’équipe, engagement et convivialité."
    mode="contain-blur"
    heightClass="h-[48vh] md:h-[62vh]"
    focal="50% 45%"   // ajuste si besoin
    alt="CSVBV - Accueil"
  />
);

export default Hero;
